<script>
import contactList from "../components/contact-archive/contact-list.vue";
import groupList from "../components/contact-archive/group-list.vue";
import PageHeading from "../components/global/PageHeading.vue";

export default {
  components: {
    contactList,
    groupList,
    PageHeading,
  },
  data() {
    return {
      activeTab: this.$route.query.tab === "groups" ? "groups" : "contacts",
      steps: [
        {
          target: "#contacts_page_heading",
          content:
            "These are the people who review and approve your proofs. Manage them here.",
          params: { placement: "bottom" },
        },
      ],
      tourCallbacks: {
        onStop: () => window.$A.SaveCompletionOfProductTours("contact-archive"),
      },
    };
  },
  computed: {
    pageDescription() {
      return this.activeTab === "groups"
        ? "Sets of contacts you can add to a workflow in one step."
        : "People who review and approve your proofs.";
    },
  },
  methods: {
    selectTab(tab) {
      if (this.activeTab === tab) return;
      this.activeTab = tab;
      const query = tab === "groups" ? { tab: "groups" } : {};
      this.$router.replace({ query }).catch(() => {});
    },
  },
  mounted() {
    this.$A.ClearViewData();
    window.$A.ProductTourProcess("contact-archive", this);
  },
};
</script>

<template>
  <div class="nav-margin">
    <navigation></navigation>
    <PageHeading
      anchor-id="contacts_page_heading"
      title="Contacts"
      :description="pageDescription"
    >
      <template #tabs>
        <div class="archive-tabs" role="tablist" aria-label="Contacts sections">
          <button
            type="button"
            role="tab"
            class="archive-tab"
            :class="{ active: activeTab === 'contacts' }"
            :aria-selected="activeTab === 'contacts' ? 'true' : 'false'"
            data-cy="contacts-tab"
            @click="selectTab('contacts')"
          >
            Contacts
          </button>
          <button
            type="button"
            role="tab"
            class="archive-tab"
            :class="{ active: activeTab === 'groups' }"
            :aria-selected="activeTab === 'groups' ? 'true' : 'false'"
            data-cy="groups-tab"
            @click="selectTab('groups')"
          >
            Groups
          </button>
        </div>
      </template>
    </PageHeading>
    <contact-list v-show="activeTab === 'contacts'" />
    <group-list v-show="activeTab === 'groups'" />
    <v-tour
      name="contact-archive"
      :steps="steps"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<style scoped>
.archive-tabs {
  display: flex;
  gap: 24px;
}

.archive-tab {
  appearance: none;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 0 2px 10px;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.archive-tab:hover {
  color: #1b1b1c;
}

.archive-tab:focus-visible {
  outline: 2px solid #019256;
  outline-offset: 2px;
  border-radius: 2px;
}

.archive-tab.active {
  color: #019256;
  border-bottom-color: #019256;
}
</style>
